import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.css'
import Button from '../../../../components/Button'
import { useDispatch, useSelector } from 'react-redux'
import { getReportData, getReportsList } from '../../../../actions/reports'
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside'
import cn from 'classnames'
import Loader from '../../../../components/Loader'
import { getCertificationRegisterGukReport, getProtocolGuk } from './DocCreaters'
import moment from 'moment'


const REPORT_NAMES = {
  certification_register_guk: 'Реестр педагогических работников',
  protocol_guk: 'Протокол'
}


export default function ReportsGUK () {
  
  const dispatch = useDispatch()
  const { comission, userInfo } = useSelector(state => state.auth)
  const { name, data, loading } = useSelector(state => state.reports)
  const popUpRef = useRef(null)

  const [popUpOpen, setPopUpOpen] = useState(false)
  const [reportName, setReportName] = useState('')
  
  useOnClickOutside(popUpRef, () => setPopUpOpen(false))

  useEffect(() => {
    dispatch(getReportsList())
  }, [])
  
  useEffect(() => {
    if (name !== reportName) return;
    const { callback, title } = getReportProps(reportName)
    createPdfDoc(callback, title)
    setPopUpOpen(false)
    setReportName('')
  }, [reportName, data])
  

  const getCurrentReport = (reportName) => async () => {
    setReportName(reportName)
    await dispatch(getReportData(reportName))
    
  }

  const getReportProps = (reportName) => {
    let callback, title
    switch (reportName) {
      case 'certification_register_guk':
        callback = getCertificationRegisterGukReport
        break;
      case 'protocol_guk':
        callback = getProtocolGuk
        break;
      default:
        callback = getProtocolGuk
        break;
    }
    title = REPORT_NAMES[reportName]
    return { callback, title }
  }

  const createPdfDoc = (createDataCB, title) => {
    createDataCB({data, comission, userInfo}).then(doc => doc.save(`${title}.pdf`))
  }

  const togglePopUp = () => setPopUpOpen(!popUpOpen)

  const renderLi = (uri_report_name) => <li onClick={getCurrentReport(uri_report_name)}>{REPORT_NAMES[uri_report_name]}</li>

  const certificationRegisterTable = () => (
      <table  hidden id='certificationRegisterTable'>
        <thead>
          <tr>
            <th>№ п/п</th>
            <th>№ п/п по ДОУ</th>
            <th>Наименование образовательного учреждения</th>
            <th>ФИО аттестуемого</th>
            <th>Категория по заявлению</th>
            <th>Должность</th>
            <th>Месяц проведения аттестации</th>
            <th>Количество баллов по портфолио / награды</th>
            <th>Примечание/Отметка о поступлении</th>
          </tr>
          <tr>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
            <td>6</td>
            <td>7</td>
            <td>8</td>
            <td>9</td>
          </tr>
        </thead>
        <tbody>
          {data && Object.keys(data).map((orgName, index) => {
            const reqCount = data[orgName].length
            const groupIndex = Object.values(data).slice(0, index).reduce((accum, group) => accum + group.length, 0)
            return (
              <>
                {data[orgName].map((req, index) => {
                  const attestationDate = req.attestation_date && moment(req.attestation_date).format('MMMM YYYY')
                  const completed = req.is_custom_status ? '+' : ''
                  const pointsAwards = req.simple_cert ? req.awards?.map(({name}) => name).join(', ') : req.user_points
                  
                  return (
                    <tr>
                      <td>{groupIndex + index + 1}</td>
                      <td>{index + 1}</td>
                      {!index && <td rowSpan={reqCount}>{orgName}</td>}
                      <td>{req.full_user_name}</td>
                      <td>{req.category}</td>
                      <td>{req.attestation_name}</td>
                      <td>{attestationDate}</td>
                      <td>{pointsAwards}</td>
                      <td>{completed}</td>
                    </tr>
                  )
                })}
                <tr>
                  <td colSpan={9}>{`Итого: ${reqCount} педагогических работника`}</td>
                </tr>
              </>
            )
          })}
        </tbody>
      </table>
  )

  return (
    <div ref={popUpRef} className={styles.popUpWrap}>

      <Button label={"Отчеты ГУК"} onClick={togglePopUp}/>

      <ul className={cn(styles.popUp, {[styles.popUpOpen]: popUpOpen})}>
        {loading ? <Loader wrapperStyle={{marginTop: '0'}}/> : Object.keys(REPORT_NAMES).map(renderLi)}
      </ul>

      {name === 'certification_register_guk' && certificationRegisterTable()}

    </div>
  )
}
